import React from "react";
import { useNavigate } from "react-router-dom";

const PromoSection = () => {
    const navigate = useNavigate();
  const styles = {
    section: {
      position: "relative",
      backgroundImage:
        "url('https://res.cloudinary.com/defcamc5x/image/upload/v1762092234/v5zkbqdrhhigvw1jtnmc.webp')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: "#fff",
      textAlign: "center",
      padding: "120px 20px",
      fontFamily: "'Poppins', sans-serif",
      overflow: "hidden",
    },
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background:
        "linear-gradient(rgba(43, 35, 25, 0.8), rgba(43, 35, 25, 0.8))",
      zIndex: 1,
    },
    content: {
      position: "relative",
      zIndex: 2,
      maxWidth: "800px",
      margin: "0 auto",
      animation: "fadeIn 2s ease-in-out",
    },
    title: {
      fontSize: "64px",
      color: "#d2b48c",
      fontWeight: "bold",
      marginBottom: "20px",
      letterSpacing: "2px",
    },
    subtitle: {
      fontSize: "22px",
      color: "#e5e2d6",
      marginBottom: "15px",
    },
    tagline: {
      fontSize: "18px",
      color: "#c5c19a",
      letterSpacing: "1px",
      marginBottom: "40px",
    },
    button: {
      backgroundColor: "#b08b56", // بني ذهبي
      color: "#fff",
      border: "none",
      padding: "14px 32px",
      fontSize: "16px",
      borderRadius: "30px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      textTransform: "uppercase",
      letterSpacing: "1px",
    },
  };

  return (
    <section style={styles.section}>
      <div style={styles.overlay}></div>
      <div style={styles.content}>
        <h1 style={styles.title}>L’ARTISAN</h1>
        <p style={styles.subtitle}>Where wood becomes art.</p>
        <p style={styles.tagline}>
          Handcrafted décor & timeless wooden creations.
        </p>
       <button
  style={styles.button}
  onClick={() => navigate("/shop")} // هذا يحولك لصفحة Contact
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#4b5320"; // زيتوني غامق
    e.target.style.transform = "scale(1.05)";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "#b08b56";
    e.target.style.transform = "scale(1)";
  }}
>
  Explore Collection
</button>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </section>
  );
};

export default PromoSection;
